export const searchUtils = {
  methods: {
    mapStoreObjectAndSearch(storeObject, searchKeys, searchString) {
      let returnValue = [];
      for (const element of this.$store.getters[storeObject]) {
        for (const key of searchKeys) {
          if (element[key].indexOf(searchString) > -1) {
            returnValue.push(element);
            break;
          }
        }
      }
      return returnValue;
    },
    searchStoreList(storeKey, searchString, mapToField = null) {
      if (this.$store.getters[storeKey] && Array.isArray(this.$store.getters[storeKey])) {
        const resultList = mapToField
          ? this.$store.getters[storeKey].map(item => item[mapToField])
          : this.$store.getters[storeKey];
        if (!searchString) return resultList;

        const result = resultList.filter(item => {
          const pat = new RegExp(searchString.trim().toLowerCase());
          return pat.test(item);
        });
        return result;
      }
    }
  }
};
